
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getInquirySheetHistory, getDraftPriceType } from "@/api/inquiry";
import { getHistoryPrice, downloadHistoryPrice } from "@/api/order-library";
import { DraftModel } from "../types";
import { deepClone } from "@/utils/deepClone";
import Pagination from "@/components/Pagination/index.vue";
import { Loading } from "element-ui";

@Component({
  name: "History",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private selectedItem: any;
  @Prop({ default: "" }) private customerId: "";
  @Prop({ default: false }) private inquirySheetId: "";
  private form = {
    startTime: null,
    endTime: null,
  };
  // private loading = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {label: "S/N",
      prop: "sn",
      key: "sn",
      type:"sn-popver",
      show: true,
      fixed: true,
      disabled: false,
      icon6: require("@/assets/images/ic_customer_sample.png"),
      icon_key6: "sample",
      icon_value6: true,
      icon_key6_1: "sampleType",
      icon_value6_1: "CUSTOMER",
      content6: "工厂付款，客人不收费",
      icon7: require("@/assets/images/ic_supplier_sample.png"),
      icon_key7: "sample",
      icon_value7: true,
      icon_key7_1: "sampleType",
      icon_value7_1: "SUPPLIER",
      content7: "工厂不付款，客人收费",
      icon8: require("@/assets/images/ic_sample.png"),
      icon_key8: "sample",
      icon_value8: true,
      icon_key8_1: "sampleType",
      icon_value8_1: "ALL",
      content8: "不收付样品"
    },
    {
      label: "供应商名称",
      prop: "supplierAbbr",
      key: "supplierAbbr",
      show: true,
      disabled: false,
    },
    {
      label: "采购价格",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      show: true,
      disabled: false,
    },
    {
      label: "单价类型",
      prop: "unitPriceType",
      key: "unitPriceType",
      show: true,
      disabled: false,
      width: 100,
    },
    {
      label: "销售价格",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      show: true,
      disabled: false,
    },
    {
      label: "利润率",
      prop: "profitRate",
      key: "profitRate",
      show: true,
      disabled: false,
    },
    {
      label: "价格来源",
      prop: "priceResource",
      key: "priceResource",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
      show: true,
      disabled: false,
    },
    {
      label: "PO",
      prop: "poNumber",
      key: "poNumber",
      show: true,
      disabled: false,
    },
    {
      label: "生产批次号",
      prop: "batchNumber",
      key: "batchNumber",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
  ] as any;
  // private newSelectedItem = {} as DraftModel;
  private newSelectedItem = {} as any;
  private newCustomerId = "";

  @Watch("selectedItem", { immediate: true })
  private async watchData() {
    // this.newSelectedItem = deepClone(this.selectedItem);
  }

  @Watch("customerId", { immediate: true })
  private async watchDataCustomerId() {
    this.newCustomerId = deepClone(this.customerId);
  }
  private list = [
    {
      label: "时间",
      prop: "time",
      key: "time",
      type: "datePicker",
      rules: {
        required: true,
        message: "请选择时间",
        trigger: "change",
      },
    },
  ];
  created() {
    // this.getListCreate();
  }
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  // private async getDraftPriceType() {
  //   const res: any = await getDraftPriceType();
  //   res.forEach((item) => {
  //     item.id = item.name;
  //     item.name = item.desc;
  //   });
  //   let index = this.tableCol.findIndex((item) => {
  //     return item.key === "unitPriceType";
  //   });
  //   this.tableCol[index].typeList = res;
  // }
  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.getList(this.form);
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }
  public loading: Boolean = false;
  private async getListCreate(item) {
    console.log("传过来的item", item);
    this.newSelectedItem = item;
    let params = {
      customerId: this.newCustomerId,
      productNumberId: item.productNumberId,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    }
    this.loading = true;
    await getHistoryPrice(params).then(({ total, list }: any) => {
         list.forEach((item, index) => {
        item.sn =
            (index + 1) * 1 + (this.table.pageNumber - 1) * this.table.pageSize;
      });
      this.table.total = +total;
      this.table.list = list;
      this.loading = false;
    }).catch(err => {
      console.log(err);
      this.loading = false;
    });
  }

  //
  private async getList(form: any) {
    this.loading = true;
    const params = Object.assign({}, form);
    const { time, ...rest } = params;
    // if (time && time.length) {
    //   rest.startTime = time[0];
    //   rest.endTime = time[1];
    // }
    try {
      let params = {
        customerId: this.newCustomerId,
        productNumberId: this.newSelectedItem.productNumberId,
        startTime: time[0],
        endTime: time[1],
        pageNumber: this.table.pageNumber,
        pageSize: this.table.pageSize,
      };
      const { total, list }: any = await getHistoryPrice(params);
      list.forEach((item, index) => {
        item.sn =
            (index + 1) * 1 + (this.table.pageNumber - 1) * this.table.pageSize;
      });
      this.table.total = +total;
      this.table.list = list;
      this.loading = false;
    } catch {}
  }

  // 下载历史报价单 接口  downloadHistoryPrice
  private async downloadHistoryPrice() {
    let params = {
      customerId: this.newCustomerId,
      productNumberId: this.newSelectedItem.productNumberId,
    };
    await downloadHistoryPrice(params);
    this.$notify({
      title: "成功",
      message: "下载成功",
      type: "success",
    });
  }
}
